/** 青山科技奖章程 */
import React from 'react';
import './regulation.scss';
export default function article() {
  return (
    <div className="rule-wrap-qs">
      <div className="sx-title">第一章 总 则</div>
      <div className="sx-content"></div>
      <div className="sx-title">第一条</div>
      <div className="sx-content">为推动绿色发展，实现美丽中国愿景蓝图，鼓励更多科研工作者投身绿色和可持续发展等领域的科技研发，特设立“青山科技奖”。</div>
      <div className="sx-title">第二条</div>
      <div className="sx-content">奖项由美团发起并资助，中国石油和化学工业联合会作为战略合作伙伴共同参与，相关学会和行业组织共同支持。本奖项奖金以及日常运作费用由“美团青山科技基金”资助和列支。</div>
      <div className="sx-title">第三条</div>
      <div className="sx-content">本奖项为公益项目，不收取任何费用，奖项的申请、评审和授奖，严格遵循公平、公正、公开的原则，杜绝任何组织或个人超越章程的干涉评奖过程行为。</div>
      <div className="sx-title">第二章 奖项设置</div>
      <div className="sx-title">第四条</div>
      <div className="sx-content">面向在中国内地及港澳地区全职工作的45周岁及以下青年科研工作者，并满足以下条件：</div>
      <div className="sx-content">(一) 无颠覆国家政权、破坏祖国统一、煽动民族、宗教仇恨的言行；</div>
      <div className="sx-content">(二) 具有完全民事行为能力；</div>
      <div className="sx-content">(三) 未因故意犯罪被追究刑事责任；</div>
      <div className="sx-content">(四) 具有良好的社会形象；</div>
      <div className="sx-content">(五) 遵循基本的道德标准；</div>
      <div className="sx-content">(六) 其他评审委员会认定的条件。</div>
      <div className="sx-title">第五条</div>
      <div className="sx-content">每年评审授奖一次，每次奖励不超过10人，奖励金额100万元/人，分三年拨付。</div>
      <div className="sx-title">第六条</div>
      <div className="sx-content">支持在材料科学、化学、化学工程、环境科学、能源科学等学科或相关交叉领域的创新研发，聚焦绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制四大议题。</div>
      <div className="sx-title">第三章 组织架构</div>
      <div className="sx-content"></div>
      <div className="sx-title">第七条</div>
      <div className="sx-content">设立评审委员会，由美团及中国石油和化学工业联合会有关负责人、院士专家、行业知名人士组成。评审委员会职责包括：审定章程与评审规则、审议年度工作安排、研究处理奖项运营工作中出现的重大问题等；</div>
      <div className="sx-content">评审委员会下设秘书处，由美团及中国石油和化学工业联合会有关人员组成，负责起草章程、评审规则及年度工作安排，负责奖项的运营、发布与传播等日常工作。</div>
      <div className="sx-title">第八条</div>
      <div className="sx-content">设立专家委员会，设主任1名、副主任1至3名、委员若干人，专家委员会一般由院士专家及行业知名人士组成。专家委员会职责包括：负责各学科领域评审工作、决定最终获奖人、审查获奖人年度科研进展等。</div>
      <div className="sx-title">第九条</div>
      <div className="sx-content">
        奖项接受青山科技奖监督委员会监督。监督委员会由经济、审计、法律、环保及公益等领域的行业权威专家组成。监督委员会职责包括：对资助形式及评审规则提出专业建议，监督评审过程、运营工作及评选结果，确保奖项公信力；受理奖项评审有关的投诉和举报，并做出处理；指导奖项制定科学有效的评估机制等。
      </div>
      <div className="sx-title">第四章 申请与授奖</div>
      <div className="sx-content"></div>
      <div className="sx-title">第十条</div>
      <div className="sx-content">候选人通过提名和自主申报两个渠道产生，每位提名人或推荐人每年可提名或推荐1位候选人。申请渠道：“美团青山科技基金”官方网站(https://greentech.meituan.com) 。</div>
      <div className="sx-title">第十一条</div>
      <div className="sx-content">评审采用两级评审机制，以学科确定分组，以投票表决方式确定拟授奖人选，最终授奖人选应由到会专家的三分之二及以上多数通过。评审表决规则如下：</div>
      <div className="sx-content">(一) 初评以网络评审方式，打分与限额投票表决产生初评结果。</div>
      <div className="sx-content">(二) 终审以多媒体答辩方式，由终审专家评委无记名投票表决产生拟授奖人选名单。</div>
      <div className="sx-title">第十二条</div>
      <div className="sx-content">评审标准：综合考虑候选人在所属学科领域的前沿探索及应用潜力，并评价已取得科研成果未来科研工作规划对相关议题研究的贡献及价值。</div>
      <div className="sx-title">第十三条</div>
      <div className="sx-content">候选人提交资料不应涉及国家安全、国家秘密或国防相关项目内容，否则不予受理。</div>
      <div className="sx-title">第十四条</div>
      <div className="sx-content">评审实行回避制度，与申请人有亲属关系或利益关联的专家，应当在评审过程中主动回避。</div>
      <div className="sx-title">第十五条</div>
      <div className="sx-content">异议及处理：</div>
      <div className="sx-content">(一) “青山科技奖”接受社会监督，任何单位和个人对拟授奖人选持有异议的，均可在结果公示之日起30日内以书面形式提出。</div>
      <div className="sx-content">(二) 对拟授奖人选提供的技术内容或情况不实等提出异议，属实质性异议，其异议由监督委员会处理。必要时可组织专家进行调查核实，报监督委员会裁决。</div>
      <div className="sx-content">(三) 剽窃、侵夺他人科研成果的，或者以其它不正当手段骗取奖励的，经监督委员会调查核准后撤消其获奖资格并追回已拨付奖金。</div>
      <div className="sx-title">第十六条</div>
      <div className="sx-content">该奖项由美团颁发证书和奖金。</div>
      <div className="sx-title">第五章 附 则</div>
      <div className="sx-content"></div>
      <div className="sx-title">第十七条</div>
      <div className="sx-content">获奖人受资助期间，应按要求向专家委员会提交年度科研进展报告并不定期参与相关公益和科普活动。</div>
      <div className="sx-title">第十八条</div>
      <div className="sx-content">参与该奖项工作的全部人员，均对涉及奖项的情况负有保密义务。</div>
      <div className="sx-title">第十九条</div>
      <div className="sx-content">本章程由美团、中国石油和化学工业联合会负责解释。</div>
      <div className="sx-title">第二十条</div>
      <div className="sx-content">本章程自发布之日起实施。</div>
      <div className="sx-title text-r">青山科技奖秘书处</div>
      <div className="sx-title text-r">2024年8月</div>
    </div>
  );
}
